import {useViewport, withinOrWiderThan} from '@udemy-v2/react-layout-components';
import {motion, useScroll, useTransform} from 'motion/react';
import {Suspense, useRef} from 'react';

import {Loading} from 'src/components/loading/loading';
import {TextRevealByLetter} from 'src/components/text-reveal/text-reveal';

import styles from './about-us.module.scss';

const SUBTEXT = `The Udemy Innovation Studio is where we $ dream up and build out new ways of
                    learning. $ We prototype new course formats, instructor $ tools, and learning
                    experiences that help you $ stay ahead in a rapidly changing world.`;
const MOBILE_SUBTEXT = `The Udemy Innovation $ Studio is where we dream $ up and build out new $ ways of learning. We $ prototype new course $ formats, instructor tools, $ and learning experiences $ that help you stay ahead $ in a rapidly changing $ world.`;

function AboutUs() {
    const {range} = useViewport();
    const isWideViewport = range && withinOrWiderThan(range, 'xl');
    const ref = useRef<HTMLDivElement>(null);
    const {scrollYProgress} = useScroll({target: ref, offset: ['150% end', 'end start']});

    const scale = useTransform(scrollYProgress, [0, 0.1, 1], [0, 1, 1]);
    const height = useTransform(scrollYProgress, [0, 0.1, 1], [0, 0, 155]);

    return (
        <section className={styles.aboutUs} id="about">
            <div className={styles.subtext} ref={ref}>
                <Suspense fallback={<Loading />}>
                    <TextRevealByLetter>
                        {isWideViewport ? SUBTEXT : MOBILE_SUBTEXT}
                    </TextRevealByLetter>
                </Suspense>
            </div>
            <div className={styles.line}>
                <motion.div className={styles.circle} style={{scale}} custom={0} />
                <motion.div className={styles.lineItem} style={{height}} custom={1} />
            </div>
        </section>
    );
}

export {AboutUs};
